import { z } from "zod";
/**
 * Tag Validation Schemas
 */
/**
 * Schema for creating a tag
 */
export const createTagSchema = z.object({
    name: z.string().min(1).max(50).trim(),
    color: z
        .string()
        .regex(/^#[0-9A-Fa-f]{6}$/, "Must be a valid hex color")
        .optional()
        .default("#3B82F6"), // Default blue
});
/**
 * Schema for adding tag to result
 */
export const addTagToResultSchema = z.object({
    resultId: z.number().int().positive(),
    tagId: z.number().int().positive(),
});
/**
 * Schema for removing tag from result
 */
export const removeTagFromResultSchema = z.object({
    resultId: z.number().int().positive(),
    tagId: z.number().int().positive(),
});
/**
 * Schema for deleting a tag
 */
export const deleteTagSchema = z.object({
    id: z.number().int().positive(),
});
//# sourceMappingURL=tag.schema.js.map